import { cx } from "@/utils";

const Spinner = ({ className, ...props }) => (
  <div
    className={cx(
      "h-6 w-6 animate-spin rounded-full border-2 border-t-2 border-white border-t-zinc-600",
      className,
    )}
    {...props}
  />
);
export default Spinner;
